import React from 'react';
import { getBlock, updateLocalCampaignBlock } from './../../Services/Api.service';
import { string, object } from 'yup';
import { translate } from '../../../Services/translation';

export const localCampaignModel = {
    root: 'settings',
    item: 'block',
    title: "Blocks",
    systemId: "systemId",
    forbidCreateNew: true,
    forbidEditAction: true,
    forbidShowBlockAction: true,
    forbidDeleteAction: true,
    requestGetItem: getBlock,
    requestPostData: updateLocalCampaignBlock,
    children: [
        {
            root: 'articles',
            item: 'article'
        },
        {
            root: 'employees',
            item: 'employee',
        }
    ],
    headers: [
        {
            headerName: "title",
            label: "Title",
            typeName: "String",
            isHiddenInIndex: false,
            isHiddenInForm: false,
            isDisabled: false
        }, {
            headerName: "titleHeader",
            label: "Title Header",
            typeName: "String",
            isHiddenInIndex: false,
            isHiddenInForm: false,
            isDisabled: false
        }, {
            headerName: "description",
            label: "Description",
            typeName: "Editor",
            isHiddenInIndex: false,
            isHiddenInForm: false,
            isDisabled: false
        }, {
            headerName: "campaignLink",
            label: "Campaign Link",
            typeName: "String",
            isHiddenInIndex: false,
            isHiddenInForm: false,
            isDisabled: false
        }, {
            headerName: "campaignLinkText",
            label: "Campaign Link Text",
            typeName: "String",
            isHiddenInIndex: false,
            isHiddenInForm: false,
            isDisabled: false
        }, {
            headerName: "campaignFromDate",
            label: "Campaign From Date",
            typeName: "Date",
            isHiddenInIndex: true,
            isHiddenInForm: false,
            isDisabled: false,
        }, {
            headerName: "campaignToDate",
            label: "Campaign To Date",
            typeName: "Date",
            isHiddenInIndex: false,
            isHiddenInForm: false,
            isDisabled: false
        }, {
            headerName: "isVisible",
            label: "Is Visible",
            typeName: "Boolean",
            isHiddenInIndex: true,
            isHiddenInForm: true,
            isDisabled: true
        }, {
            headerName: "systemId",
            label: "SystemId",
            typeName: "String",
            isHiddenInIndex: true,
            isHiddenInForm: true,
            isDisabled: true
        }, {
            headerName: "systemId",
            label: "SystemId",
            typeName: "String",
            isHiddenInIndex: true,
            isHiddenInForm: true,
            isDisabled: true
        }, {
            headerName: "templateId",
            label: "Template Id",
            typeName: "String",
            isHiddenInIndex: true,
            isHiddenInForm: true,
            isDisabled: true
        }, {
            headerName: "templateSystemId",
            label: "Template System Id",
            typeName: "String",
            isHiddenInIndex: true,
            isHiddenInForm: true,
            isDisabled: true
        }
    ],
    validation: object().shape({
        campaignFromDate: string().required(translate(`validation.required`)),
        campaignToDate: string().required(translate(`validation.required`))
    })
}